import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Activity Notification Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const ActivityChallengesNotifications = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'activitynotification.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template notification successfully created!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activitynotification.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template notification successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activitynotification.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template notification successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );

        default:
            return null;
    }
};

ActivityChallengesNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

ActivityChallengesNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default ActivityChallengesNotifications;
